module.exports = __webpack_public_path__ + "img/wsczzhjkyypt13.621562d7.png";